import React, {
  useContext,
  useEffect,
  useCallback,
  useMemo,
} from 'react';
import { RPCFactory } from '../../../utils/RequestUtil';
import { Context, ACTIONS } from './store';

const listItemWithComponent = (list = [], Component) => {
  const getComponent = (data) => {
    const key = [data.title, data.id].join('-');
    return (<Component key={key} data={data} />);
  };
  return list.map(getComponent);
};

const SubCatalog = ({ data }) => {
  const { dispatch } = useContext(Context);

  const gotoDetail = () => {
    dispatch({
      type: ACTIONS.GO_TO_DETAIL,
      payload: {
        title: data.name,
        id: data.catalog_id,
      },
    });
  };

  return (
    <li onClick={gotoDetail}>
      <span>{ data.name }</span>
      <i className="spaui-icon icon-arrow-mini" />
    </li>
  );
};

const Catalog = ({ data }) => {
  return (
    <div>
      <p className="item-tt">{ data.name }</p>
      <ul className="item-list">
        { listItemWithComponent(data.children, SubCatalog) }
      </ul>
    </div>
  );
};

export const SubHeader = () => {
  const { state, dispatch } = useContext(Context);

  const data = useMemo(() => {
    let prev = state.menuItem.title;
    let title = '首页';
    if (state.type === 'detail') {
      title = '返回';
      prev = null;
    }
    return { title, prev };
  }, [state]);

  const goBack = useCallback(() => {
    const actionMap = {
      menu: ACTIONS.BACK_TO_HOME,
      detail: ACTIONS.BACK_TO_MENU,
    };
    dispatch({ type: actionMap[state.type] });
  }, [state.type, dispatch]);

  return (
    <div className="topdes">
      <div className="topbar">
        <div className="back" onClick={goBack}>
          <span className="bac">
            <i className="spaui-icon icon-back" />
          </span>
          { data.title }
        </div>
        { data.prev && (<p className="hd">{ data.prev }</p>) }
      </div>
    </div>
  );
};

const Menu = ({ id }) => {
  const { state, dispatch } = useContext(Context);
  const data = useMemo(() => {
    const defaultData = { children: [] };
    if (id !== state.menuItem.id) return defaultData;
    return state.menuItem.data || defaultData;
  }, [id, state.menuItem]);

  const getCatalog = useCallback(() => {
    if (!id) return;
    const setData = resData => dispatch({
      type: ACTIONS.SET_MENU_DATA,
      payload: resData,
    });
    RPCFactory.quickHelp
      .getCatalog(id)
      .done(setData)
      .fail((_, msg) => alert(msg));
  }, [id, dispatch]);

  useEffect(getCatalog, [getCatalog]);

  return (
    <div className="help-home">
      <SubHeader />
      <div className="items">
        { listItemWithComponent(data.children, Catalog) }
      </div>
    </div>
  );
};

export default Menu;
